import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { getGruser } from '../selectors';
import { getCanCreateGroupGalleryFolder, getCanRearrangeGroupGalleryFolders } from '../../utils/groupPrivs';
export const useGlobalPrivs = ()=>_object_spread({}, useMMSelector((state)=>{
        var _gruser, _gruser1;
        const gruser = getGruser(state);
        return {
            canRearrangeGalleryFolders: !((_gruser = gruser) === null || _gruser === void 0 ? void 0 : _gruser.isGroup) || getCanRearrangeGroupGalleryFolders(gruser.extendedGroup),
            canCreateGalleryFolder: !((_gruser1 = gruser) === null || _gruser1 === void 0 ? void 0 : _gruser1.isGroup) || getCanCreateGroupGalleryFolder(gruser.extendedGroup)
        };
    }));
export default ((component)=>connectMediaStore((state)=>{
        var _gruser, _gruser1;
        const gruser = getGruser(state);
        return {
            canRearrangeGalleryFolders: !((_gruser = gruser) === null || _gruser === void 0 ? void 0 : _gruser.isGroup) || getCanRearrangeGroupGalleryFolders(gruser.extendedGroup),
            canCreateGalleryFolder: !((_gruser1 = gruser) === null || _gruser1 === void 0 ? void 0 : _gruser1.isGroup) || getCanCreateGroupGalleryFolder(gruser.extendedGroup)
        };
    })(component)); // redux is a bit dumb with generics
